export type Language = "en" | "id";

export const translations: Record<Language, Record<string, string>> = {
  en: {},
  id: {
    " (download started)": " (unduhan dimulai)",
    ". If you have selected a vector layer - click on the vectors to generate statistics for them.":
      ". Jika Anda telah memilih layer vektor - klik vektor untuk menghasilkan statistiknya.",
    Acquired: "Diperoleh",
    Acquisitions: "Akuisisi",
    "Agree and proceed": "Setujui dan lanjutkan",
    "Alternatively,": "Sebagai alternatif,",
    "Altitude (ft)": "Ketinggian (ft)",
    Analysis: "Analisis",
    "ArborCarbon Help": "Bantuan ArborCarbon",
    "Are you sure you want to delete this feature?":
      "Apakah Anda yakin ingin menghapus fitur ini?",
    Area: "Area/kawasan",
    Back: "Kembali",
    "Back to boundary select": "Kemhali ke pemilihan batas",
    "Base Layer": "Layer Dasar",
    Boundary: "Batas",
    "Boundary Information": "Informasi Batas",
    Cancel: "Batal",
    "Change filters": "Ubah filter",
    Clear: "Bersihkan",
    Client: "Klien",
    Close: "Tutup",
    "Company Logo": "Logo Perusahaan",
    Compare: "Bandingkan",
    Completed: "Selesai",
    Country: "Negara",
    Create: "Buat",
    "Create Feature": "Buat Fitur",
    "Create Feature Here": "Buat Fitur di Sini",
    "Create Project": "Buat Pekerjaan",
    Created: "Dibuat",
    Data: "Data",
    "Data tab": "tab Data",
    Date: "Tanggal",
    Delete: "Hapus",
    "Delete Feature": "Hapus Fitur",
    Description: "Deskripsi",
    Documentation: "Dokumentasi",
    Download: "Unduh",
    "Draw on the screen to generate analysis on the current active layers for that area. To change these layers, go to the":
      "Gambar pada layar untuk menghasilkan analisis pada layer aktif saat ini di area tersebut. Untuk mengubah layer ini, buka",
    "Drawn Feature": "Fitur yang digambar",
    Edit: "Edit",
    "Enter an ID": "Masukkan ID",
    FAQs: "Tanya Jawab (FAQ)",
    "Feature: {title} successfully created": "Fitur: {title} berhasil dibuat",
    "Feature: {title} successfully deleted": "Fitur: {title} berhasil dihapus",
    "Feature: {title} successfully updated":
      "Fitur: {title} berhasil diperbarui",
    Features: "Fitur",
    Filter: "Saring (Filter)",
    "Filter Boundaries": "Saring (Filter) Batas",
    "Filter features": "Saring (Filter) fitur",
    "Filter layer": "Saring (Filter) layer",
    "Filter one or more properties of the features. When filtered, only features that match all filtered properties will be shown.":
      "Saring (Filter) satu atau lebih properti fitur. Saat disaring (Filter), hanya fitur yang memenuhi semua kriteria yang akan ditampilkan.",
    "Frequently Asked Questions": "Pertanyaan yang Sering Diajukan",
    "GSD (cm)": "GSD (cm)",
    "Get Started": "Mulai",
    "Get Support": "Dapatkan Dukungan",
    "Give Feedback": "Beri Masukan",
    "Help Tabs": "Tab Bantuan",
    "#### Unknown Page\n\nWe haven't documented this page yet - sorry! Please click on the Get Support tab to let us know what you were trying to do and we'll get back to you as soon as we can.":
      "#### Halaman Tidak Dikenal\n\nKami belum mendokumentasikan halaman ini - maaf! Silakan klik tab Dapatkan Dukungan untuk memberi tahu kami apa yang ingin Anda lakukan dan kami akan segera menghubungi Anda.",
    "Hide values higher than range": "Sembunyikan nilai di atas rentang",
    "Hide values lower than range": "Sembunyikan nilai di bawah rentang",
    "How are we doing?": "Bagaimana pengalaman Anda?",
    "How can I share or save my results?":
      "Bagimana cara membagikan atau menyimpan hasil saya?",
    "I can't find the left panel": "Saya tidak dapat menemukan panel kiri",
    "I can't log in / Something is missing / I would like access / I would like to give access to someone else":
      "Saya tidak dapat masuk / Ada yang hilang / Saya ingin akses / Saya ingin memberikan akses kepada orang lain",
    "I have a feature request": "Saya memiliki permintaan fitur",
    "I have forgotten my password": "Saya lupa kata sandi",
    "I would like to report a bug/performance issue":
      "Saya ingin melaporkan bug/masalah kinerja",
    ID: "ID",
    "ID Search": "Pencarian ID",
    "ID search": "Pencarian ID",
    "If you need more help, please go to":
      "Jika Anda membutuhkan bantuan lebih lanjut, silakan buka",
    "Image Types": "Jenis Citra",
    "In Progress": "Sedang Piproses",
    "Latest Acquisition": "Akuisisi Terbaru",
    "Left Side Data": "Data Sisi Kiri",
    "Log out": "Keluar",
    Login: "Masuk",
    "Lower bound of colour scaling": "Batas bawah skala warna",
    Max: "Maks",
    Mean: "Rata-rata",
    Menu: "Menu",
    Min: "Min",
    Name: "Nama",
    "Need more help?": "Butuh bantuan lebih lanjut?",
    "New Project": "Pekerjaan Baru",
    "No Data Available for download. Have you selected the correct acquisition?":
      "Tidak ada data yang tersedia untuk diunduh. Apakah Anda telah memilih akuisisi yang benar?",
    "No features in this project yet. Draw on the map to get started.":
      "Belum ada fitur dalam proyek ini. Gambar pada peta untuk memulai.",
    "No overlay layers are selected. To select layers, go to the":
      "Tidak ada layer overlay yang dipilih. Untuk memilih layer, buka",
    "No properties": "Tidak ada properti",
    "No results": "Tidak ada hasil",
    None: "Tidak ada",
    "Open in new window": "Buka di jendela baru",
    "Overlay {index}": "Overlay {index}",
    "PDF Documentation": "Dokumentasi PDF",
    Photos: "Foto",
    'Please click Login and then "Forgot Password?" to reset your password.':
      'Silakan klik Masuk lalu "Lupa Kata Sandi?" untuk mengatur ulang kata sandi Anda.',
    "Please go to": "Silakan buka",
    "Please let us know by": "Silakan beri tahu kami dengan",
    "Project: {name} successfully created": "Proyek: {name} berhasil dibuat",
    Projects: "Pekerjaan",
    "Reset Filters": "Atur Ulang Filter",
    "Right Side Data": "Data Sisi Kanan",
    "Satellite, streets and places": "Satelit, jalan, dan tempat",
    Search: "Cari",
    Source: "Sumber",
    Layer: "Layer",
    "Search for a boundary based on name, state, country or target":
      "Cari batas berdasarkan nama, provinsi, negara, atau target",
    "Search for a particular feature by its ID":
      "Cari fitur tertentu berdasarkan ID",
    "See all acquisitions": "Lihat semua akuisisi",
    "See below for a video on how to use the tool.":
      "Lihat video di bawah untuk panduan penggunaan.",
    "Select ArborCam Data": "Pilih Data ArborCam",
    "Select Status...": "Pilih Status...",
    "Select a project": "Pilih pekerjaan",
    "Selected Feature": "Fitur terpilih",
    Show: "Tampilkan",
    "Something went wrong saving these details, please try again":
      "Terjadi kesalahan saat menyimpan data ini, silakan coba lagi",
    State: "Provinsi",
    "Statistics for {title}": "Statistik untuk {title}",
    Stats: "Statistik",
    Status: "Status",
    Table: "Tabel",
    Tags: "Tag",
    Target: "Target",
    "Terms and Conditions": "Syarat dan Ketentuan",
    "The following imagery data is available for download. By downloading the imagery you agree to only use it for agreed purposes and not to distribute it without permission.":
      "Data citra berikut tersedia untuk diunduh. Dengan mengunduh data ini, Anda setuju untuk menggunakannya hanya untuk tujuan yang disepakati dan tidak menyebarkannya tanpa izin.",
    "The left panel can be hidden by clicking the X in the top left corner of the page. To show the left panel again, click the hamburger menu in the top left corner of the page.":
      "Panel kiri dapat disembunyikan dengan mengklik X di pojok kiri atas halaman. Untuk menampilkannya kembali, klik menu hamburger di pojok kiri atas.",
    "The {siteTitle} is designed to be used in a web browser. You can bookmark the page to save your specific data configuration. You can also share the URL with others to share your results, as long as they have an account and access to the same data.":
      "{siteTitle} dirancang untuk digunakan di peramban jejaring (web browser). Anda dapat menandai halaman ini untuk menyimpan konfigurasi data Anda. Anda juga dapat membagikan URL kepada pengguna lain yang memiliki akun dan akses data yang sama.",
    Title: "Judul",
    "To view and analyse the data, select a boundary (using the dropdown or by selecting on the map) then click 'View Data'. Additional help can be accessed using the":
      "Untuk melihat dan menganalisis data, pilih batas (melalui dropdown atau dengan memilih di peta) lalu klik 'Lihat Data'. Bantuan tambahan dapat diakses dengan menggunakan",
    "Tutorial Video": "Video Tutorial",
    "Type and press enter to add tags":
      "Ketik dan tekan enter untuk menambahkan tag",
    Unknown: "Tidak diketahui",
    "Unknown date": "Tanggal tidak diketahui",
    Update: "Perbarui",
    "Update Feature": "Perbarui Fitur",
    "Upload Image": "Unggah Gambar",
    "Upper bound of colour scaling": "Batas atas skala warna",
    "Veg Strata": "Strata Vegetasi",
    "Vegetation Strata": "Strata Vegetasi",
    "Vertical tabs": "Tab vertikal",
    "View Data": "Lihat Data",
    Welcome: "Selamat Datang",
    "and fill out a request.": "dan isi permintaan.",
    "and fill out a request. In the mean-time, if you encounter issues, refreshing the page may help.":
      "dan isi permintaan. Sementara itu, jika Anda mengalami masalah, memuat ulang halaman mungkin membantu.",
    "filling out this form": "silakan isi formulir berikut",
    "giving us feedback": "berikan masukan kepada kami",
    "icon at the top right of the screen - the help will automatically update based on the currently active view.":
      "ikon di kanan atas layar - bantuan akan otomatis diperbarui sesuai tampilan yang sedang aktif.",
    "simple table": "tabel sederhana",
    "you can download the documentation as a PDF.":
      "Anda dapat mengunduh dokumentasi dalam format PDF.",
    "{name} Selected Feature": "{name} Fitur terpilih",
  },
};
